module.exports = __webpack_public_path__ + "img/0b0209f777acdb3cc82338993c203afd.cd9f97f4.png";